import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { injectIntl, defineMessages } from 'react-intl'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { notificationTexts } from '../../common/config'
import { updateNotifications } from '../../common/notifications/actions'

class NotificationsHeader extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      visibleNotifications: false,
    }
  }

  componentDidCatch(error, info) {
    console.log('error - NotificationsHeader')
    console.log(error)
    console.log('info')
    console.log(info)
  }

  componentDidMount() {
    window.addEventListener('click', () => {
      this.setState({
        visibleNotifications: false,
      })
    })
  }

  handleClick(e) {
    e.stopPropagation()
    this.setState({
      visibleNotifications: !this.state.visibleNotifications,
    })
  }

  render() {
    const { notifications, updateNotifications, intl } = this.props
    const { visibleNotifications } = this.state

    const hasNewNotifications = notifications.some(n => !n.seen)

    return (
      <div
        className="notifications-header"
        onClick={e => this.handleClick(e)}
      >
        <FontAwesomeIcon icon="bell" size="2x" />
        {
          hasNewNotifications && <div className="notifications-new" />
        }
        {
          visibleNotifications && notifications &&
          <div className="notifications-links">
            <div
              className="mark-all-as-read"
              onClick={() => updateNotifications()}
            >
              {intl.formatMessage(messages.markAllAsRead)}
            </div>
            {
              notifications.length ?
                notifications.map(notification => (
                  <div
                    key={notification.id}
                    className={`notifications-links-item ${notification.seen ? '' : 'not-seen'}`}
                  >
                    <Link to={`${notification.link}?notification=${notification.id}`}>
                      {`${notificationTexts[notification.type]} ${notification.text}`}
                    </Link>
                  </div>
                ))
              :
                <div className="notifications-links-item">
                  <p>{intl.formatMessage(messages.noNotifications)}</p>
                </div>
            }
          </div>
        }
      </div>
    )
  }
}

NotificationsHeader.propTypes = {
  intl: PropTypes.object.isRequired,
  notifications: PropTypes.array.isRequired,
  updateNotifications: PropTypes.func.isRequired,
}

const enhance = compose(
  withRouter,
  connect(state => ({
    notifications: state.notifications.all,
  }), { updateNotifications }),
  injectIntl,
)

export default enhance(NotificationsHeader)

const messages = defineMessages({
  markAllAsRead: {
    id: 'notificationsHeader.markAllAsRead',
    defaultMessage: 'Označiť všetky ako prečítané',
  },
  noNotifications: {
    id: 'notificationsHeader.noNotifications',
    defaultMessage: 'Zatiaľ žiadne notifikácie.',
  },
})



// WEBPACK FOOTER //
// ./src/browser/components/NotificationsHeader.js